import useSession from 'hooks/useSession'
import { isPastTimestamp } from '@ca/common'
import { trpc } from 'api'
import { create } from 'zustand'
import Analytics from 'hooks/analytics/Analytics'

export const useHeadlessStaffLoginState = create<{
  isLoading: boolean
  setLoading: (v: boolean) => void
}>((set) => ({
  isLoading: false,
  setLoading: (v: boolean) => set({ isLoading: v }),
}))

const useHeadlessStaffLogin = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: (staffRef: string) => void
}) => {
  const setLoading = useHeadlessStaffLoginState((s) => s.setLoading)
  const store = useSession((s) => s.store)
  const isValidStore = !!store?.token && !isPastTimestamp(store.exp)

  const setStaff = useSession((s) => s.setStaff)

  const staffLogin = trpc.staff.staffLogin.useMutation({
    onMutate: () => setLoading(true),
    onSettled: () => setLoading(false),
    onSuccess: (data) => {
      setStaff(data)

      Analytics.logEvent('staff_login', {
        staff_id: `${data.data.id}`,
        staff_ref: data.data.ref,
      })
      onSuccess?.()
    },
    onError: (_, req) => {
      onError?.(req.ref)
    },
  })

  const login = (staffId: string) => {
    staffLogin.mutate({
      ref: staffId,
    })
  }

  return {
    isValidStore,
    store,
    login,
  }
}

export default useHeadlessStaffLogin
